import { useState } from "react";
import {
  ConsultaTourContext,
  consultaTourDefault,
  ConsultaTourPasseio,
} from "./ConsultaTourContext";

export function ConsultaTourProvider({ children }: { children: JSX.Element }) {
  const [passeio, setPasseio] =
    useState<ConsultaTourPasseio>(consultaTourDefault);

  return (
    <ConsultaTourContext.Provider value={{ passeio, setPasseio }}>
      {children}
    </ConsultaTourContext.Provider>
  );
}
